import { Fade } from '@material-ui/core';
import React from 'react';
import { useInView } from 'react-intersection-observer';

const InViewContainer: React.FC<{
  placeholder?: React.ComponentType;
  fade?: boolean;
}> = ({ placeholder: Placeholder, fade, children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  if (fade) {
    return (
      <Fade in={inView} timeout={300}>
        <div ref={ref}>
          {!inView && Placeholder && <Placeholder />}
          {inView && children}
        </div>
      </Fade>
    );
  }
  return (
    <div ref={ref}>
      {!inView && Placeholder && <Placeholder />}
      {inView && children}
    </div>
  );
};

export default InViewContainer;
